import React from 'react'

import {BrowserRouter as Router, Route, Switch, Link, Redirect} from 'react-router-dom'

// import * as ROUTES from '../../constants/routes';
// e.g. ROUTES.LANDING

import HTLanding from './components/HTLandingPage.js'
import HTSearchPage from './components/HTSearchPage'
import HTFullContent from './components/HTFullContent'

import lessonsArray from './content/lessons.js'

const contentRoutes = lessonsArray.map((content) => {
  let path = "/lesson/"+content.path
  return(<Route path={path} exact render={(props) => <HTFullContent {...props}  content={content} /> } key={content.path+"_route"} />)
})

function HTRouter (props) {

  return (
    <Router>
    <Switch>
      <Route exact path="/" component={HTLanding} />
      <Route path="/search/post" render={(props) => <HTSearchPage {...props}  includeFAQs={false} /> } />
      <Route path="/search/faq" render={(props) => <HTSearchPage {...props}  includeLessons={false} /> } />
      <Route path="/search" component={HTSearchPage} />
      {contentRoutes}
    </Switch>
    </Router>
  )
}

/*<Route path="/lesson" render={(props) => <HTFullContent {...props} content={contentArray[0]} /> } />*/

export default HTRouter



// WEBPACK FOOTER //
// src/HTRouter.js